import React from 'react';

const SectionRecruitUnified = ({ event, setEvent }) => {
  return (
    <section id="recruit_unified">
      <div className="container col-md-8 col-lg-6" style={{ paddingTop: 8 }}>
        <div
          style={{
            background: '#fff',
            border: '1px solid #ececee',
            borderRadius: 16,
            padding: '14px 16px',
            boxShadow: '0 1px 2px rgba(30,30,40,.03), 0 10px 26px -16px rgba(30,30,40,.14)',
          }}
        >
          <div style={{ marginBottom: 6 }}>
            <span style={{ fontSize: 12, fontWeight: 800, color: '#666' }}>参加者</span>
          </div>
          <p style={{ fontSize: 11.5, color: '#8B9097', margin: '0 0 12px', lineHeight: 1.55 }}>
            つなげーとに集客を一本化するとイベントページにその旨が表示されます。オン（つなげーとで全ての参加者を管理）にしているイベントを表示上で優遇します。
          </p>
          <div className="custom-control custom-switch custom-switch-md">
            <input
              type="checkbox"
              className="custom-control-input"
              id="is_recruit_unified"
              checked={event.is_recruit_unified}
              onChange={(e) => {
                setEvent((prev) => ({
                  ...prev,
                  is_recruit_unified: e.target.checked,
                }));
              }}
            />
            <label className="custom-control-label" htmlFor="is_recruit_unified">
              つなげーとの予約システム以外で、参加者を募集、または参加予定者がいない
            </label>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionRecruitUnified;
